import Button from 'components/Form/Button';
import { Icon } from 'components/Icon';
import { useEffect, useState } from 'react';
import { LogoSpinner } from 'screens/Dashboard/Home/styled';
import { Title } from 'ui/styled';
import { theme } from 'ui/theme-color';
import { ProposalSteps } from './ProposalSteps';
import { ConfirmDisplayContainer, ConfirmDisplayWrapper } from './styled';

export const EproposalConfirm = ({ isMobile, logoURL }) => {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    document.fonts.load('24px "Material Symbols Outlined"').then(() => {
      setFontLoaded(true);
    });
  }, []);

  const spinnerImagePath = '/images/circulo_tes2.svg';

  return fontLoaded ? (
    <ConfirmDisplayWrapper>
      <ConfirmDisplayContainer>
        {logoURL && (
          <img src={logoURL} alt="Logo" style={{ maxHeight: '3rem' }} />
        )}
        <Icon
          name={'check_circle'}
          size={80}
          color={theme.palette.success.main}
          fill
        />
        <span
          style={{
            textAlign: 'text',
            width: '60%',
          }}
        >
          <Title centred>Proposta Enviada com Sucesso!</Title>
          <p>
            Obrigado por enviar sua proposta. Nossa equipe entrará em contato
            com você em breve para dar continuidade ao processo.
          </p>
        </span>
        {!isMobile && (
          <ProposalSteps
            icon1={{
              name: 'check_circle',
              color: theme.palette.success.main,
              fill: true,
            }}
            icon2={{ name: 'circle_circle', color: theme.palette.purple.main }}
            icon3={{
              name: 'circle_circle',
              color: theme.palette.colors.lightgrey,
            }}
          />
        )}
        <div
          style={{
            display: 'grid',
            gap: isMobile && '1rem',
            gridTemplateColumns: !isMobile && '1fr auto 1fr',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Icon
              name={'upload'}
              size={36}
              fill
              color={theme.palette.success.main}
            />
            <div
              style={{
                width: '65%',
              }}
            >
              <Title small nomargin centred>
                Envio Recebido
              </Title>
              <p>Recebemos sua proposta com sucesso!</p>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Icon
              name={'Schedule'}
              size={36}
              color={theme.palette.purple.main}
            />
            <div
              style={{
                width: '65%',
              }}
            >
              <Title small nomargin centred>
                Em Análise
              </Title>
              <p>Nossa equipe está analisando os detalhes de sua proposta.</p>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Icon name={'call'} size={36} color={theme.palette.primary.main} />
            <div
              style={{
                width: '65%',
              }}
            >
              <Title small nomargin centred>
                Contato
              </Title>
              <p>Entraremos em contato em breve.</p>
            </div>
          </div>
        </div>
        <hr
          style={{
            height: '2px',
            width: '90%',
          }}
        />
        <a
          style={{
            textDecoration: 'none',
          }}
          href="https://www.evontech.com.br/"
        >
          <Button
            color="purple"
            width={'fit-content'}
            fontSize={18}
            endIcon={
              <Icon
                name={'line_end_arrow_notch'}
                size={24}
                elementAttributes={{ style: { marginLeft: '8px' } }}
              />
            }
          >
            Conheça a Evon
          </Button>
        </a>
        <p>Aproveite para conhecer mais sobre as nossas soluções.</p>
      </ConfirmDisplayContainer>
    </ConfirmDisplayWrapper>
  ) : (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LogoSpinner src={spinnerImagePath} alt="Logo rotativo" />
    </div>
  );
};
